// extracted by mini-css-extract-plugin
module.exports = {"root":"UfoAnimation-module--root---yMgb","show":"UfoAnimation-module--show--38Cac"};